import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=45ea20ab&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=45ea20ab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea20ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ea20ab')) {
      api.createRecord('45ea20ab', component.options)
    } else {
      api.reload('45ea20ab', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=45ea20ab&scoped=true", function () {
      api.rerender('45ea20ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/SAMROralInstructionScreen/Main.vue"
export default component.exports